/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, OnInit, OnDestroy } from "@angular/core";
import { EventBusService, BusEvent } from "@html-core";

@Component({
   standalone: false,
   selector: "ajax-busy-overlay",
   template: `
      <div [hidden]="!showAjaxBusyOverlay">
         <div class="ajax-busy-overlay">
            <div class="ajax-busy-icon"><div></div></div>
         </div>
      </div>
   `
})
export class AjaxBusyOverlayComponent implements OnInit, OnDestroy {
   public showAjaxBusyOverlay: boolean = false;
   ngOnInit() {
      this.eventBusService.listen(BusEvent.AjaxBusyMsg.MSG_TYPE).subscribe((msg: BusEvent.AjaxBusyMsg) => {
         this.showAjaxBusyOverlay = msg.busy;
      });
   }
   ngOnDestroy() {
      //We don't need to unsubscribe the ajaxBusy$
   }

   constructor(private eventBusService: EventBusService) {}
}
